import React from "react";
import { Area, AreaChart, XAxis, YAxis } from "recharts";
import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

interface MessagesByDay {
  date: string
  messages: number
  sent: number
  received: number
}

interface StatsWithSingleChartProps {
  data: MessagesByDay[]
  loading?: boolean
}

const chartConfig = {
  messages: {
    label: "Total de Mensagens",
    color: "#A1A1AA",
  },
} satisfies ChartConfig;

const StatsWithSingleChart: React.FC<StatsWithSingleChartProps> = ({ data, loading = false }) => {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr)
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
  }

  const chartData = data.map((item, index) => ({
    x: index + 1,
    date: formatDate(item.date),
    messages: item.messages
  }))

  const totalMessages = data.reduce((sum, item) => sum + item.messages, 0)

  if (loading) {
    return (
      <div className="w-full max-w-[600px] mx-auto flex flex-col gap-3 animate-pulse">
        <div className="h-6 bg-neutral-600 rounded w-1/2"></div>
        <div className="h-[300px] bg-neutral-600 rounded"></div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-[600px] mx-auto flex flex-col gap-3">
      <h2 className="text-neutral-100 font-semibold text-[20px]">
        Atividade Geral (7 dias)
      </h2>
      <h2 className="text-[30px] text-neutral-100 font-semibold">
        {totalMessages.toLocaleString()}
      </h2>
      <ChartContainer config={chartConfig}>
        <AreaChart
          accessibilityLayer
          data={chartData}
          margin={{
            left: 0,
            right: 0,
          }}
        >
          {/* <CartesianGrid  color="#3F3F464D" opacity={.1} /> */}
          <XAxis dataKey="x" tickLine={false} axisLine={false} tickMargin={6} />
          <YAxis
            dataKey="messages"
            tickLine={false}
            axisLine={false}
            tickMargin={6}
          />
          <ChartTooltip
            cursor={false}
            content={<ChartTooltipContent indicator="line" />}
          />
          <Area
            dataKey="messages"
            type="natural"
            fill="var(--color-messages)"
            fillOpacity={0.4}
            stroke="var(--color-messages)"
          />
        </AreaChart>
      </ChartContainer>
    </div>
  );
};

export default StatsWithSingleChart;
